var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssetsManager = function SvgAssetsManager(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Assets manager_big",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.729 18.862C5.018 18.862 2 16.226 2 12.987c0-2.82 2.415-5.91 4.441-8.005a7.13 7.13 0 0 1-1.6-3.539.432.432 0 0 1 .126-.31.422.422 0 0 1 .308-.132h6.909a.441.441 0 0 1 .433.442 7.145 7.145 0 0 1-1.6 3.539 26.62 26.62 0 0 1 1.911 2.193 5.183 5.183 0 0 0-.74.475 26.185 26.185 0 0 0-1.946-2.209H7.221C5.597 7.093 2.87 10.27 2.87 12.988c0 2.752 2.629 4.991 5.859 4.991.223 0 .454-.015.688-.037a5.6 5.6 0 0 0-.167.9c-.189.014-.364.02-.521.02zM5.778 1.883a7.186 7.186 0 0 0 1.45 2.672h3a7.152 7.152 0 0 0 1.448-2.672z",
    "data-name": "Path 11599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.678 20.289v-.939a2.969 2.969 0 0 0-2.965-2.965h-1.177a2.969 2.969 0 0 0-2.966 2.965v.939h7.107m-3.553-6.386a2.459 2.459 0 1 0-2.459-2.459 2.462 2.462 0 0 0 2.459 2.459m4.353 7.186H10.77V19.35a3.77 3.77 0 0 1 3.766-3.765h1.177a3.77 3.77 0 0 1 3.765 3.765zm-4.353-6.386a3.259 3.259 0 1 1 3.259-3.259 3.263 3.263 0 0 1-3.258 3.264z",
    "data-name": "user - Outline"
  })))));
};
export default SvgAssetsManager;